import React, { useState } from 'react';
import { NDialog } from '@innersource-nn/novoui-react';
import useRejectShareObjectMutation from 'views/Shares/hooks/useRejectShareObjectMutation';
import { ModalProps } from 'types/Modal';

export interface RejectRequestModalProps extends ModalProps {
    shareUri: string;
}

export default function RejectRequestModal({
    visible,
    onClose,
    shareUri,
}: RejectRequestModalProps) {
    const useRejectShareRequest = useRejectShareObjectMutation(shareUri);
    const [loading, setLoading] = useState<boolean>(false);
    const useReject = async () => {
        setLoading(true);
        await useRejectShareRequest();
        setLoading(false);

        if (onClose) onClose();
    };
    return (
        <NDialog
            disabled={loading}
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline="Deny share request"
            primaryAction={useReject}
            primaryLabel="Deny request"
            secondaryAction={onClose}
            secondaryLabel="Cancel"
            size="medium"
            subHeadline="Are you sure you want to deny access to all requested objects within this share request?"
            showDividers={false}
        ></NDialog>
    );
}
